import { render, staticRenderFns } from "./DailyRoutineParent.vue?vue&type=template&id=21d88cf0&scoped=true"
import script from "./DailyRoutineParent.vue?vue&type=script&lang=js"
export * from "./DailyRoutineParent.vue?vue&type=script&lang=js"
import style1 from "./DailyRoutineParent.vue?vue&type=style&index=1&id=21d88cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d88cf0",
  null
  
)

export default component.exports